import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from './global.service';
import { globals } from '../globals';
import { Contato } from '../models/contato';

@Injectable({
  providedIn: 'root'
})
export class ContatoService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarContatosComPaginacao(descricao: string, cliente: boolean, vendedor, paginaAtual, qtdRegistros, campoOrdenacao,
    orientacaoOrdenacao, ativo,tipoPesquisa, pesquisa, tags?, contatoStatusSelecionado?) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('cliente', cliente.toString())
      .set('vendedor', vendedor !== undefined && vendedor !== null ? vendedor : '')
      .set('ativo', ativo !== undefined && ativo !== null ? ativo : '')
      .set('tipoPesquisa', tipoPesquisa !== undefined && tipoPesquisa !== null ? tipoPesquisa : '')
      .set('pesquisa', pesquisa ? encodeURIComponent(pesquisa) : '')
      .set('contatoStatusSelecionado', contatoStatusSelecionado ? contatoStatusSelecionado: '');

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (tags !== undefined && tags !== null) {
      parametros = parametros.set('tags', tags);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Contato/ListaPag',
      {
        params: parametros
      });
  }

  salvar(contato: Contato) {
    return this.http.post(globals.apiUrl + '/api/Contato/Salvar', contato);
  }

  atualizarStatusDoContato(idGIContato, idStatus) {
    return this.http.post<any>(globals.apiUrl + '/api/Contato/AtualizarStatusDoContato', { idGIContato, idStatus });
  }

  exportarContatos(ids, titulo) {
    let parametros = new HttpParams().set('ids', ids.toString()).set('titulo', titulo);

    return this.http.get(globals.apiUrl + '/api/Contato/ExportarContato',
      { responseType: 'blob', params: parametros }
    );
  }
}
